export default {
  pageTitle: 'Developer information'
}
